module.exports = {
  URL_API_AUTH: `${process.env.REACT_APP_URL_API}/auth/api`,
  URL_API_PRODUCT: `${process.env.REACT_APP_URL_API}/product/api`,
  URL_API_ORDER: `${process.env.REACT_APP_URL_API}/order/api`,
  NAS_URL_API: `${process.env.REACT_APP_NAS_URL_API}`,
  NAS_SECRET_KEY: `${process.env.REACT_APP_NAS_SECRET_KEY}`,
};
